import { userContext } from '../userManager';

export const apiFeesGet = ({ financialAdvisorId, clientId }) =>
  userContext.apiCall({ url: `/fees`, qs: { financialAdvisorId, clientId } });
